import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import Badge from 'flarum/common/components/Badge';

Discussion.prototype.essence = Model.attribute('essence');

export default function addEssenceBadge() {
  extend(Discussion.prototype, 'badges', function (badges) {
    if (this.essence()) {
      badges.add(
        'essence',
        Badge.component({
          type: 'essence',
          label: app.translator.trans('dl_discussion_controller.forum.essence_label'),
          icon: 'fas jh',
        }),
        10
      );
    }
  });
}
